import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

// RouteFlashTransition — global gold-radial curtain that fires on every route change.
// Mount ONCE inside <BrowserRouter> at the App level.  Adds a 0.55s expanding-flash
// + 0.65s fade-out so a user feels they've "stepped into another realm".
export const RouteFlashTransition = () => {
  const location = useLocation();
  const [tick, setTick] = useState(0); // re-key the flash on each route change
  const [firstMount, setFirstMount] = useState(true);

  useEffect(() => {
    if (firstMount) { setFirstMount(false); return; }
    setTick(t => t + 1);
  }, [location.pathname]); // eslint-disable-line react-hooks/exhaustive-deps

  if (firstMount) return null;

  return (
    <div className="route-flash" key={tick} aria-hidden="true" data-testid="route-flash">
      <span className="route-flash-core" />
      <span className="route-flash-ring" />
      <span className="route-flash-veil" />
    </div>
  );
};

export default RouteFlashTransition;
